<servicerapport-accordion-panel [formGroup]="formGroup" title="Installationsoprettelse">
    <mat-accordion>
        <mat-expansion-panel #panel [expanded]="true">
            <mat-expansion-panel-header>
                <accordion-status-indicator [formGroup]="formGroup"></accordion-status-indicator>
                <mat-panel-title>Installationsoprettelse</mat-panel-title>
            </mat-expansion-panel-header>

            <dff-form-control [formControl]="formGroup.get('dato.aktuel')"></dff-form-control>

            <mat-divider></mat-divider>

            <h2>MÅLER</h2>
            <maaler-oprettelse [formGroup]="formGroup.get('nyMaaler')"></maaler-oprettelse>
            <dff-form-control [formControl]="formGroup.get('info1.aktuel')"></dff-form-control>
            <dff-form-control [formControl]="formGroup.get('info2.aktuel')"></dff-form-control>
            <simpel-note-liste
                ingenNoterTekst=""
                [maxNoter]="1"
                [formArray]="formGroup.get('nyMaaler.noter')"
                [defaultOmraadeId]="defaultNoteOmraadeId"
                [omraader]="noteOmraader"
                [henvendelsestyper]="noteHenvendelsestyper"
                [opgavestyringStatusser]="noteOpgavestyringStatusser"
                [brugere]="noteBrugere"
                (initialiserNote)="onInitialiserNote($event, formGroup.get('nyMaaler.maalerNr.aktuel').value)"
            >
            </simpel-note-liste>

            <mat-divider></mat-divider>

            <h2>FØJ TIL HUSKELISTE</h2>
            <dff-form-control [formControl]="formGroup.get('huskelisteId.aktuel')"></dff-form-control>
        </mat-expansion-panel>
    </mat-accordion>
</servicerapport-accordion-panel>
